<template>

  <div class="contacts">
    <Hero v-bind:dark="true" />
  </div>

</template>

<script>

  // @ is an alias to /src
  import Hero from '@/components/Hero.vue'

  export default {
    name: 'contacts',
    components: {
      Hero
    },
    methods: {
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body

        if (addRemoveClass === 'addClass') {
          el.classList.add(className)
        } else {
          el.classList.remove(className)
        }
      }
    },
    mounted() {
      this.toggleBodyClass('addClass', 'is-dark')
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'is-dark')
    }
  }

</script>
